export default import.meta.ROLLDOWN_FILE_URL_HttEggsLG_LVzojYu_xHDQ